import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getPortalUrl } from '../../../state/selector/app-state/index.tsx';
import { HelpCenterChannelView } from './view.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any) => ({
	link: getPortalUrl(state),
});

export const HelpCenterChannel = connect(mapStateToProps, {})(HelpCenterChannelView);
